// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HomeTabletBannerAd_wrap__nMD8G","inner":"HomeTabletBannerAd_inner__n_jPW","header":"HomeTabletBannerAd_header__tnnwC","label":"HomeTabletBannerAd_label__O8u6H"};